// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2_VIF","validationTips":"StatementDescriptor_validationTips__bq6dL"};